import { BlueprintProvider, Styles } from '@hover/blueprint';
import React, { ReactNode } from 'react';

import { SegmentHistoryProvider } from 'src/shared/providers';

import { EphemeralEmail } from './EphemeralEmail';
import { Partner } from './Partner';
import { ProfessionalSignUp } from './ProfessionalSignUp';
import { Telemetry } from './Telemetry';

interface ProviderProps {
  children: ReactNode;
}

const Providers = ({ children }: ProviderProps) => (
  <>
    <Partner>
      <BlueprintProvider includeFonts>
        <Styles fonts={false} />
        <Telemetry>
          <SegmentHistoryProvider>
            <EphemeralEmail>
              <ProfessionalSignUp>{children}</ProfessionalSignUp>
            </EphemeralEmail>
          </SegmentHistoryProvider>
        </Telemetry>
      </BlueprintProvider>
    </Partner>
  </>
);

export { Providers };
